
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#55A3FF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.988 9.797H4.5a.703.703 0 00-.703.705l.01 5.341a.703.703 0 001.406 0v-1.621l.775-.003c1.235 0 2.24-.992 2.24-2.211 0-1.22-1.005-2.211-2.24-2.211zm0 3.016l-.778.002a194.55 194.55 0 01-.005-1.612h.783c.452 0 .834.369.834.805 0 .436-.382.805-.834.805zM11.969 9.797H10.5a.703.703 0 00-.703.704l.01 5.187a.703.703 0 00.704.7h.002c.045 0 1.092-.004 1.51-.011 1.59-.028 2.743-1.41 2.743-3.284 0-1.972-1.124-3.296-2.797-3.296zm.03 5.174c-.182.003-.495.006-.788.008l-.007-3.776h.765c1.29 0 1.39 1.446 1.39 1.89 0 .923-.42 1.861-1.36 1.878zM19.4 11.149a.703.703 0 100-1.406h-2.15a.703.703 0 00-.703.703v5.304a.703.703 0 001.406 0v-2h1.276a.703.703 0 000-1.405h-1.276v-1.196H19.4z","fill":"inherit"}}),_c('path',{attrs:{"d":"M21.469 6.797h-.516v-.2c0-.905-.342-1.764-.964-2.42l-2.92-3.08A3.53 3.53 0 0014.516 0h-9.36c-1.164 0-2.11.946-2.11 2.11v4.687H2.53c-1.163 0-2.11.946-2.11 2.11v8.437c0 1.163.947 2.11 2.11 2.11h.516v2.437c0 1.163.946 2.109 2.11 2.109h13.687c1.163 0 2.11-.946 2.11-2.11v-2.437h.515c1.163 0 2.11-.946 2.11-2.11V8.907c0-1.163-.947-2.11-2.11-2.11zM4.453 2.109c0-.387.316-.703.703-.703h9.361c.576 0 1.134.24 1.53.658l2.921 3.081c.373.394.579.909.579 1.451v.2H4.453V2.11zm15.094 19.782a.704.704 0 01-.703.703H5.156a.704.704 0 01-.703-.703v-2.438h15.094v2.438zm2.625-4.547a.704.704 0 01-.703.703H2.53a.704.704 0 01-.703-.703V8.906c0-.387.316-.703.703-.703H21.47c.387 0 .703.316.703.703v8.438z","fill":"inherit"}})])
          )
        }
      }
    